import { Component, OnInit } from '@angular/core';
import { SwiperOptions } from 'swiper';

@Component({
  selector: 'app-swiper-services',
  templateUrl: './swiper-services.component.html',
  styleUrls: ['./swiper-services.component.scss']
})
export class SwiperServicesComponent implements OnInit {
  public ConfiguracionSlider: SwiperOptions = {

		init: true,
		speed: 500,
    slidesPerView:  2,
    spaceBetween: 0,
    loop: true,
    navigation: {
      nextEl: "#serv-button-next",
      prevEl: "#serv-button-prev",
    },
    breakpoints: {
      // when window width is >= 700px
      700: {
        slidesPerView: 3,
      }
    },

	};
  public products = [
    {
      img: './assets/images/icons/products/1.png',
      data: 'product description',
      title: 'Nombre del producto'
    },
    {
      img: './assets/images/icons/products/2.png',
      data: 'product description',
      title: 'Nombre del producto'
    },
    {
      img: './assets/images/icons/products/3.png',
      data: 'product description',
      title: 'Nombre del producto'
    },
    {
      img: './assets/images/icons/products/1.png',
      data: 'product description',
      title: 'Nombre del producto 2'
    },
    {
      img: './assets/images/icons/products/2.png',
      data: 'product description',
      title: 'Nombre del producto 3'
    },
    {
      img: './assets/images/icons/products/3.png',
      data: 'product description',
      title: 'Nombre del producto 4'
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
